export const isConfirmPaymentMethodSuccessfully = (state) => !!state.payment.stripe.setupIntent;
